import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, query } from "firebase/firestore";
import { initializeApp, getApps } from "firebase/app";
import "./Marquee.css";

const firebaseConfig = {
  apiKey: "AIzaSyDuI4z1Eq1Na-a7pRapholyTmRfC9D-pkY",
  authDomain: "mkmthangamaligai-a4e5c.firebaseapp.com",
  projectId: "mkmthangamaligai-a4e5c",
  storageBucket: "mkmthangamaligai-a4e5c.appspot.com",
  messagingSenderId: "999444851582",
  appId: "1:999444851582:web:177cf17fb7103257c9212f",
  measurementId: "G-R7ZSYLF51Y",
};

// Avoid re-initializing Firebase if already initialized
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const db = getFirestore(app);

const Marquee = () => {
  const [rates, setRates] = useState(null);

  useEffect(() => {
    const fetchRates = async () => {
      const q = query(collection(db, "goldRates"));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          setRates(doc.data());
        });
      }
    };
    fetchRates();
  }, []);

const marqueeText = rates
  ? `நம் நெல்லையில் MKM தங்க மாளிகை! இன்றைய தங்க விலை கிராம் ஒன்றிற்கு 24k- Rs.14,962, 22k- Rs.13,715, 18k- Rs.11,222, வெள்ளி கிராம் ஒன்றிற்கு Rs.265/-`
  : "விலை தகவல் ஏற்றுகிறது...";

  return (
    <div className="marquee-wrapper">
      <div className="marquee-container-custom">
        <div className="marquee-text-custom">
          {marqueeText}
        </div>
      </div>
    </div>
  );
};

export default Marquee;